<template>
  <group class="mtb20" v-show="isShow">
    <cell class="usedcar-brand-info" :bdStart="true">
      <img slot="icon" class="brand-img" :src="carDetail.brand_logo">
      <p slot="after-title" class="usedcar-brand">{{carDetail.car_model_name}}</p>
      <a slot="after-title" class="red_btn" @click.stop="operate" v-if="operateInfo.show">{{operateInfo.title}}</a>
    </cell>
    <cell class="usedcar-detail">
      <p slot="after-title"><span>线索编号</span>{{carDetail.id}}</p>
      <p slot="after-title"><span>车架号</span>{{carDetail.vin || '--'}}</p>
      <!-- 缺车架号 -->
      <p slot="after-title"><span>车牌号</span>{{carDetail.plate_number}}</p>
      <p slot="after-title"><span>首次上牌</span>{{carDetail.license_issued_on}}</p>
      <!-- 字段多了个e -->
      <p slot="after-title"><span>行驶里程</span>{{carDetail.mileage}}</p>
      <p slot="after-title"><span>车身颜色</span>{{carDetail.jzg_color_name}}</p>
      <p slot="after-title"><span>过户次数</span>{{carDetail.transfer_count}}次</p>
      <p slot="after-title"><span>车辆归属地</span>{{carDetail.vehicle_province}}，{{carDetail.vehicle_city}}</p>

    </cell>
    <!-- 查车况 -->
    <div class="inquiry-condition-carDetail">
      <cell is-link :link="reportObj.link">
      <p slot="icon">{{ reportObj.title }}</p>
      <p class="after-title">{{ reportObj.linkText }}</p>
    </cell>
    </div>
    <cell class="usedcar-detail" v-if="!showPrice">
      <p slot="after-title">
        <span>车主姓名</span>
        {{carDetail.owner_name}}
      </p>
      <p slot="after-title">
        <span>车主手机</span>
        <a :href="`tel:${carDetail.owner_mobile}`" style="color: #5890ff;">{{carDetail.owner_mobile}}</a>
      </p>
      <router-link
        v-if="editAuth"
        :to="`/usedcar/edit/ownerInfo?id=${carDetail.id}&owner_name=${carDetail.owner_name}&owner_mobile=${carDetail.owner_mobile}`"
        tag="span"
        class="edit-btn"
      >编辑</router-link>
    </cell>
    <cell class="usedcar-detail" v-if="!showPrice">
      <p slot="after-title" v-if="carDetail.source.source_id !== 1"><span>线索来源</span>{{carDetail.channel_name}}</p>
      <p slot="after-title" ><span>置换情况</span>{{carDetail.replace_detail_name}}</p>
      <p slot="after-title">
        <span class="special-title">备注</span>
        <span class="special ect">{{carDetail.note | defaultShow}}</span>
      </p>
      <p slot="after-title"><span>来源</span>{{carDetail.source.source_name}}</p>
      <p slot="after-title" v-if="carDetail.source.source_id !== 1">
        <span class="special-title">来源人</span>
        <span class="special ect">{{hasSource}}</span>
      </p>
      <p slot="after-title">
        <span class="special-title">来源人手机</span>
        <span class="special" v-if="carDetail.source.sourcer_mobile">
          <a :href="`tel:${carDetail.source.sourcer_mobile}`" style="color: #5890ff;">{{carDetail.source.sourcer_mobile}}</a>
        </span>
        <span class="special" v-else>--</span>
      </p>
      <p slot="after-title">
        <span class="special-title">提交者</span>
        <span class="special ect">{{carDetail.submitter.name}} ({{carDetail.submitter.role}})</span>
      </p>
      <p slot="after-title">
        <span class="special-title">提交者手机</span>
        <span class="special"><a :href="`tel:${carDetail.submitter.mobile}`" style="color: #5890ff;">{{carDetail.submitter.mobile}}</a></span>
      </p>
    </cell>
    <cell class="usedcar-detail" v-if="!showPrice && carDetail.submitter.mobile">

    </cell>
    <cell class="usedcar-detail" v-if="showPrice">
      <p slot="after-title"><span>市场参考价</span>{{carDetail.reference_price | formatePrice01}}</p>
      <p slot="after-title"><span>本店评估价</span>{{carDetail.appraised_price | formatePrice02}}</p>
    </cell>
  </group>
</template>
<script>
import { Group, Cell } from '@lx-frontend/cvux'

export default {
  components: { Group, Cell },
  props: {
    operateInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
          title: ''
        }
      }
    },
    showPrice: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: true
    },
    carDetail: {
      type: Object,
      default: () => {
        return {
          source: {},
          submitter: {}
        }
      }
    }
  },
  data() {
    return {
      editAuth: false
    }
  },
  created() {
    this.$store.state.promiseAuth.then(auth => {
      this.editAuth = auth.authList.includes('used_car_ticket.update_owner')
    })
  },
  filters: {
    formatePrice01(price) {
      return price ? `${(price / 100).toFixed(2)}元（来源精真估）` : '--'
    },
    formatePrice02(price) {
      return price ? `${(price / 100).toFixed(2)}元` : '--'
    },
    defaultShow(value) {
      return value ? `${value}` : '--'
    }
  },
  computed: {
    hasSource() {
      let source = this.carDetail.source
      if (source.sourcer_role) { // # 当线索来源为销售/售后放行时才不为空
        return `${source.sourcer_name} (${source.sourcer_role})`
      } else {
        return '--'
      }
    },
    reportObj () {
      const {
        is_queryed: isQueryed,
        order_id: orderId,
        id
      } = this.carDetail || {}
      if (!isQueryed) {
        return {
          link: `/usedcar/inquiry/${id}?stage=2`,
          title: '历史车况（未查询）',
          linkText: '去查车况'
        }
      }
      if (orderId) {
        return {
          link: `${window.location.origin}/api/v1/cbs/get_cbs_report_detail?order_id=${orderId}`,
          title: '历史车况（已查询）',
          linkText: '查询结果'
        }
      }
      return {
        link: `/usedcar/inquiry/process/${id}`,
        title: '历史车况（已查询）',
        linkText: '查询结果'
      }
    }
  },
  methods: {
    operate() {
      this.$emit('on-go')
    }
  }
}

</script>
<style lang="less">
@import "../../stylesheets/modules/components/cardetail.less";
.inquiry-condition-carDetail {
  padding: 10/@w 0;
  background-color: #eee;
  .weui_cell {
    background-color: #fff;

    &_hd {
      font-size: 13/@w;
      color: #979797;
    }

    &_ft {
      font-size: 13/@w;
      color: rgb(88, 144, 255);
    }
  }
}
</style>
